(function() {
    'use strict';
    
    angular.module('SMART2').directive('smartPlaceholder', ['$translate', 'ScrollTo', function ($translate, ScrollTo) {
        return {
            restrict: 'A',
            replace: true,
            link: function (scope, element, attrs) {
                window.activePlaceholder = element;
				var tmpPlaceholder = getHTMLPlaceholder(scope);
                element.addClass((!scope.property.isMandatory ? 'optionalField ' : '') + ((scope.property.attributes.readonly ? 'readOnlyField' : '')));
                element.find('.smart-ph-label').html('<span>' + $translate.instant(scope.property.label) + '</span>');
                element.find('.smart-ph-value').html('<span>' + tmpPlaceholder + '</span>');
                element.attr('title', tmpPlaceholder);
				
				if (tmpPlaceholder != '') {
                    element.find('.smart-ph-label').addClass('active');
                }

                if (scope.property.attributes.disable || scope.property.attributes.readonly) {
                    element.find('.smart-ph-value').addClass('disabled');
                }
                else {
                    element.attr('tabindex', 0);
                }
				
                var onAttributesChange = scope.$watchGroup(['property.attributes.disable', 'property.attributes.readonly', 'model.' + scope.property.data, 'property.validate', 'property.focus'], function (newVal, oldVal) {
					//	disable and readonly change listener
					if(!angular.equals(newVal[0], oldVal[0]) || !angular.equals(newVal[1], oldVal[1])) {
					    if (newVal[0] || newVal[1]) {
					        element.find('.smart-ph-value').addClass('disabled');
					        element.attr('tabindex', -1);
					    }
					    else {
					        element.find('.smart-ph-value').removeClass('disabled');
					        element.attr('tabindex', 0);
					    }
					}
					
					//	data change listener
					if(!angular.equals(newVal[2], oldVal[2])) {
						tmpPlaceholder = getHTMLPlaceholder(scope);
						element.find('.smart-ph-value').html('<span>' + tmpPlaceholder + '</span>');
						element.attr('title', tmpPlaceholder);
						if (tmpPlaceholder != '') {
							element.find('.smart-ph-label').addClass('active');
						}
						else {
						    element.find('.smart-ph-label').removeClass('active');
						}
					}

                    //	validate change listener
					if (!angular.equals(newVal[3], oldVal[3])) {
					    if (scope.property.validate) {
					        if ((angular.isUndefined(scope.property.attributes.readonly) || scope.property.attributes.readonly == false) &&
                                (angular.isUndefined(scope.property.attributes.disable) || scope.property.attributes.disable == false)) {
					            validate();
					        }
					        scope.property.validate = false;
					    }
					}

                    //	focus change listener
					if (!angular.equals(newVal[4], oldVal[4])) {
					    if (scope.property.focus) {
					        ScrollTo.perform(element, angular.element('#' + scope.formWidgetId));
					        scope.onFocus();
					        scope.property.focus = false;
					    }
					}
                });

                var validate = function () {
                    var model = eval('scope.model.' + scope.property.data);
                    var error;

                    if(scope.property.isMandatory) {
                        if ((scope.property.attributes.type === 'text' || angular.isUndefined(scope.property.attributes.type)) && (angular.isUndefined(model) || model == null || model.trim() == '')) {
                            error = $translate.instant("enterValueErrMsg");
                        }
                        else if (scope.property.attributes.type == 'autocomplete' && (angular.isUndefined(model) || model == null || model == '' || (model && model.hasOwnProperty('value') && model.value.trim() == ''))) {
                            error = $translate.instant("enterValueErrMsg");
                        }
                        else if (scope.type == 'number' && isNaN(scope.ngModel)) {
                            error = $translate.instant("enterNumberErrMsg");
                        }
                    }

                    if (angular.isUndefined(error) && scope.property.rules) {
                        var rules = scope.property.rules;

                        for (var i = 0; i < rules.length; i++) {
                            if (typeof rules[i] == 'object') {
                                if (eval((rules[i].rule).replace(/this/g, model))) {
                                    error = rules[i].error;
                                    break;
                                }
                            }
                        }
                    }

                    if (error) {
                        element.find('.smart-ph-label').addClass('active');
                        element.find('.smart-ph-value').addClass('invalid');
                        element.find('.smart-ph-error').html(error);
                        //scope.$parent.errorMessage = error;
                    }
                    else {
                        element.find('.smart-ph-value').removeClass('invalid');
                        element.find('.smart-ph-error').html('');
                        if (tmpPlaceholder == '') {
                            element.find('.smart-ph-label').removeClass('active');
                        }
                        //scope.$parent.errorMessage = undefined;
                    }
                };

                //validate();
                
                scope.onFocus = function (e) {
                    if (scope.property.attributes.disable || scope.property.attributes.readonly) {
                        return;
                    }
                    scope.$parent.isPreviewMode = false;
                };

                scope.onRemoveButtonClick = function (e) {
                    scope.property.isVisible = !scope.property.isVisible;
                    e.stopPropagation();
                };

                scope.$parent.onEditableRender = function (editableScope, editableEle) {
                    editableEle.find('input').focus();
                    editableEle.find('input').select();
                    element.attr('tabindex', -1);
                    if (this.errorMessage) {
                        editableEle.find('input').addClass('invalid');
                        editableEle.find('label').attr('data-error', this.errorMessage);
                        this.errorMessage = undefined;
                    }
                };

                scope.$parent.onStopEdit = function (editableScope, editableEle) {
                    this.isPreviewMode = true;
                    if (editableScope.errorMessage != undefined || editableScope.errorMessage != null) {
                        this.errorMessage = editableScope.errorMessage;
                        setTimeout(function () {
                            window.activePlaceholder.find('.smart-ph-label').addClass('active');
                            window.activePlaceholder.find('.smart-ph-value').addClass('invalid');
                            window.activePlaceholder.find('.smart-ph-error').html(editableScope.errorMessage);
                        });
                    }
                };

                scope.$on('$destroy', function () {
                    onAttributesChange();
                });
            },
            templateUrl: 'shared/directives/uiElements/smartSection/smartPlaceholderTemplate.html'
        };
    }]);

	
	var setPrecisionLimits = function (number, decimalPrecision, minMaxPrecision) {
        if (number != undefined) {
            var arr = (number.toString()).split('e')
            if (arr.length > 1 && parseInt(arr[1]) < 0) {
                number = (number).toFixed(6);
            }
            var tempArr = number.toString().split('.');
            if (tempArr != undefined && tempArr.length > 1) {
                var preDecimal = tempArr[0];
                if (preDecimal != 0 && preDecimal.toString().length > 20) {
                    var tempVal = preDecimal.toString().substring(0, 19);
                    number = parseInt(tempVal);
                }
            }
            else {
                if (number != 0 && number.toString().length > 20) {
                    var tempVal = number.toString().substring(0, 19);
                    number = parseInt(tempVal);
                }
            }
            if (decimalPrecision != undefined) {
                number = parseFloat(parseFloat(number).toFixed(decimalPrecision));
            }
            else if (minMaxPrecision !== undefined && minMaxPrecision !== '') {
                var splitPrecision = JSON.parse(minMaxPrecision);
                if (splitPrecision.length > 2 || splitPrecision.length < 1) {
                    //	don't do anything
                }
                else {
                    var lowerPrecisionLimit = splitPrecision[0];
                    var highPrecisionLimit = splitPrecision[1];

                    var postDecimalNumbers = ((number + "").split(".")[1] != undefined) ? (number + "").split(".")[1].length : 0;

                    if (postDecimalNumbers == 0) {
                        //	don't do anything
                    }
                    else if (lowerPrecisionLimit > postDecimalNumbers && postDecimalNumbers < highPrecisionLimit && postDecimalNumbers != 0) {
                        number = parseFloat(parseFloat(number).toFixed(lowerPrecisionLimit));
                    }
                    else if (postDecimalNumbers >= highPrecisionLimit && postDecimalNumbers != 0) {
                        var fixed = Math.pow(10, highPrecisionLimit);
                        number = Math.floor(number * fixed) / fixed;
                    }
                }
            }
        }
        return number;
    };


    var getFormattedDate = function (dateVal, dateFormat, isSetFromGrid) {
        var output = '';
        dateFormat = dateFormat.replace(/d/g, 'D').replace(/y/g, 'Y').replace(/E/g, 'd');
        var isDateBlank = false;
        var doesContainDateString = isSetFromGrid == 'true' ? true : (dateVal + '').toLowerCase().indexOf('date') > -1 ? true : false;

        if (dateVal == "" || dateVal == null) {
            dateVal = Date.now();
            isDateBlank = true;
        }
        else {
            if (doesContainDateString) {
                var tmpModel = (dateVal + '').replace(new RegExp("/", "ig"), '');
                tmpModel = tmpModel.split('+');
                tmpModel = eval('new ' + (tmpModel.length > 1 ? ('Date("' + dateVal + '").getTime()') : tmpModel[0]));
                output = moment(tmpModel).format(dateFormat);
            }
            else {
                if (Object.prototype.toString.call(dateVal) !== '[object Date]') {
                    dateVal = parseInt(dateVal);
                }
            }
        }

        if (!isDateBlank) {
            if (!doesContainDateString) {
                output = moment(dateVal).format(dateFormat);
            }
        }
        else {
            output = "";
        }

        return output;
    };

    var getHTMLPlaceholder = function (scope) {
        var placeHolder;
        var tmpModel = eval("scope.model." + scope.property.data);

        switch (scope.property.type) {
            case 'textfield':
                switch (scope.property.attributes.type) {
                    case 'number':
                        placeHolder = setPrecisionLimits(tmpModel, scope.property.attributes.decimalprecision, scope.property.attributes.minmaxprecision);
                        break;

                    case 'date':
                        placeHolder = getFormattedDate(tmpModel, scope.property.attributes.format);
                        break;

                    case 'autocomplete':
                        if (tmpModel == undefined || tmpModel == null || tmpModel == '') {
                            return '';
                        }
                        var str = scope.property.attributes.displayformat, evalResult, evaluatedKeysCounter = 0, nullKeysCounter = 0;
                        try {
                            var parentSplit = str.split('{');
                            for (var j = 0; j < parentSplit.length; j++) {
                                var childSplit = parentSplit[j].split('}');
                                for (var k = 0; k < childSplit.length; k++) {
                                    if (childSplit[k].indexOf('.') > 0 || tmpModel.hasOwnProperty(childSplit[k])) {
                                        evalResult = eval('tmpModel.' + childSplit[k]);
                                        evaluatedKeysCounter++;
                                        if (evalResult == undefined || evalResult == null || (evalResult + '').trim().length == 0) {
                                            evalResult = '';
                                            nullKeysCounter++;
                                        }
                                        str = str.replace(new RegExp("{" + childSplit[k] + "}", "ig"), evalResult);
                                    }
                                }
                            }
                            if (evaluatedKeysCounter == nullKeysCounter) {
                                str = '';
                            }
                        }
                        catch (e) { }
                        str === undefined || str === null || str === 'undefined' || str === 'null' ? '' : str;
                        placeHolder = str;
                        break;

                    default:
                        placeHolder = eval("scope.model." + scope.property.data);
                        break;
                }
                break;

            case 'dropdown':
            case 'select':
                placeHolder = (eval("scope.model." + scope.property.data + (scope.property.attributes.displaykey ? "." + scope.property.attributes.displaykey : (scope.property.attributes.datakey ? "" + scope.property.attributes.datakey : ""))));
                break;
        }
        return placeHolder == null || placeHolder == undefined ? '' : placeHolder;
    };
	
})();    